import FileCardThumb from './FileCardThumb.jsx';
import FileCardActions from './FileCardActions.jsx';
import styles from './FileCard.module.css';

/**
 * Card de um arquivo ou pasta na grade do explorador.
 *
 * Responsável por: navegação (clique em pasta), edição de nome inline
 * (duplo clique), e delegar ações (view/download/play/edit/delete/share)
 * para o handler apropriado vindo do hook useFileExplorer.
 *
 * `viewMode` controla o layout: 'grid' (padrão, cards) ou 'list' (linhas).
 */
export default function FileCard({
  item,
  access,
  thumbUrl,
  isMusicContext,
  isEditing,
  newName,
  onNewNameChange,
  onRenameCommit,
  onFolderOpen,
  onEditStart,
  onView,
  onDownload,
  onPlay,
  onDelete,
  onShare,
  extra = null,
  viewMode = 'grid',
}) {
  const handleCardClick = () => {
    if (item.isDirectory) onFolderOpen(item.name);
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    if (!isEditing) onEditStart(item);
  };

  const cardClassName = viewMode === 'list' ? styles.folderList : styles.folder;

  return (
    <div
      className={cardClassName}
      onClick={handleCardClick}
      onDoubleClick={handleDoubleClick}
    >
      <FileCardActions
        item={item}
        access={access}
        onView={onView}
        onDownload={onDownload}
        onPlay={onPlay}
        onEdit={() => onEditStart(item)}
        onDelete={() => onDelete(item.name)}
        onShare={() => onShare(item)}
      />

      {extra}

      <FileCardThumb item={item} thumbUrl={thumbUrl} isMusicContext={isMusicContext} />

      <div className={styles.label}>
        {isEditing ? (
          <input
            type="text"
            value={newName}
            onChange={(e) => onNewNameChange(e.target.value)}
            onBlur={onRenameCommit}
            onKeyDown={(e) => e.key === 'Enter' && onRenameCommit()}
            autoFocus
          />
        ) : (
          item.name
        )}
      </div>
    </div>
  );
}